import script from "./Blog.vue?vue&type=script&setup=true&lang=js"
export * from "./Blog.vue?vue&type=script&setup=true&lang=js"

import "./Blog.vue?vue&type=style&index=0&id=529e758e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-529e758e"]])

export default __exports__